export const createMap = <T extends { name: string }>(array: T[]) => {
  const map = new Map<string, T>();

  array.forEach((section) => {
    map.set(section.name, section);
  });
  return map;
};
